import { all } from "redux-saga/effects";

import registerSaga from "./registerSaga";
import loginSaga from "./loginSaga";
import adminLoginSaga from "./adminLoginSaga";
import resetPasswordSaga from "./resetPasswordSaga";
import businessSaga from "./businessSaga";
import venueSaga from "./venueSaga";
import venueImageSaga from "./venueImageSaga";
import enquirySaga from "./enquirySaga";
import userSaga from "./userSaga";
import vendorSaga from "./vendorSaga";
import vendorProfileSaga from "./vendorProfileSaga";
import mailSaga from "./mailSaga";
import reviewSaga from "./reviewSaga";
import realWeddingSaga from "./realWeddingSaga";

export default function* rootSaga() {
  yield all([
    registerSaga(),
    loginSaga(),
    adminLoginSaga(),
    resetPasswordSaga(),
    businessSaga(),
    venueSaga(),
    venueImageSaga(),
    enquirySaga(),
    userSaga(),
    vendorSaga(),
    vendorProfileSaga(),
    mailSaga(),
    reviewSaga(),
    realWeddingSaga(),
  ]);
}
